import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AsteriskIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.25 1.5C7.25 1.22386 7.47386 1 7.75 1H8.25C8.52614 1 8.75 1.22386 8.75 1.5V6.18942L12.0659 2.87356C12.2611 2.67829 12.5777 2.67829 12.773 2.87356L13.1265 3.22711C13.3218 3.42237 13.3218 3.73895 13.1265 3.93422L9.81074 7.25H14.5C14.7761 7.25 15 7.47386 15 7.75V8.25C15 8.52614 14.7761 8.75 14.5 8.75H9.81058L13.1265 12.0659C13.3218 12.2612 13.3218 12.5778 13.1265 12.7731L12.773 13.1266C12.5777 13.3219 12.2611 13.3219 12.0659 13.1266L8.75 9.81074V14.5C8.75 14.7761 8.52614 15 8.25 15H7.75C7.47386 15 7.25 14.7761 7.25 14.5V9.81074L3.93414 13.1266C3.73887 13.3219 3.42229 13.3219 3.22703 13.1266L2.87348 12.7731C2.67821 12.5778 2.67821 12.2612 2.87348 12.0659L6.18942 8.75H1.5C1.22386 8.75 1 8.52614 1 8.25V7.75C1 7.47386 1.22386 7.25 1.5 7.25H6.18926L2.87348 3.93422C2.67821 3.73895 2.67821 3.42237 2.87348 3.22711L3.22703 2.87356C3.42229 2.67829 3.73887 2.67829 3.93414 2.87356L7.25 6.18942V1.5Z"
		></path>
	</svg>
))
